export default "__VITE_ASSET__DP9Sf0lR__"